// extracted by mini-css-extract-plugin
export default {"Table":"CtorL","TableSimple":"ipoXK"};